// This file centralizes the product data so it can be used across multiple components.

export const products = [
    {
        id: 1,
        name: 'BONLIN LINIMENT',
        price: '19.99',
        smalldescription: 'Emu Oil Pain Relief',
        fullDescription: 'A powerful and exclusive topical application for relief of pain with emu bird oil Emu bird oil is very well recognised in the treatment of rheumatic pains all over the world Be it a rheumatic pain, neurological or musculo-skeletal disorders relief is instant from immobility to mobility. Double action Bonlin proved to be an effective topical pain oil with Emu bird oil along with Devadaru, Gandupura Tailam, Kajuput Thailam etc.',
        image: '../assets/images/bonlin liniment.png',
        rating: 4.5,
        reviews: 120,
        inStock: true,
        category: 'Pain Relief',
    },
    {
        id: 2,
        name: 'MEMORY CALTONE Syrup',
        price: '24.99',
        smalldescription: 'Memory Boost Supplement',
        fullDescription: 'An exclusive Nutrutional supplement increases memory in children and elderly people. A perfect blend of natural herbal ingredients for under nutrition in children above 3 years Caltone activates brain cells, increases mental stamina, memory power, concentration besides supplementation of calcium. Hence physical and mental growth are ensured quickly. Increases appetite in all ages. Best for sportsmen, school going children and old people. Memory Caltone contains proven, powerful herbs like Sankhapushpi, Satavari, Brahmi, Jalabrahmi etc.',
        image: '../assets/images/memory syrup.png',
        rating: 4.8,
        reviews: 250,
        inStock: true,
        category: 'Wellness',
    },
    {
        id: 3,
        name: 'Cheveux',
        price: '9.99',
        smalldescription: 'Herbal Hair Tonic',
        fullDescription: 'CHEVEUX Herbal Hair Tonic from our sister concern SANYA NATURALS has proved in hair fall and aids in hair growth. Essential oils in our hair tonic treats specific hair problems like dandruff, premature greying of hair, and hair loss. It relieves dry and itchy scalps.',
        image: '../assets/images/cheveux.png',
        rating: 4.3,
        reviews: 95,
        inStock: false,
        category: 'Hair Care',
    },
    {
        id: 4,
        name: 'Ecliv-DS syrup',
        price: '59.99',
        smalldescription: 'Natural Digestive Syrup',
        fullDescription: 'DEEPANA Syrup: A natural digestant and appetizer of pure herbal origin. Reduces constipation and regulates bowel moment. Stimulates pancreas and improves secretion of digestive enzymes. Reduces belching and gas formation. Digests complex protein and oily fried foods. Good and acceptable taste for children also.',
        image: '../assets/images/ecliv-ds syrup.png',
        rating: 4.7,
        reviews: 310,
        inStock: true,
        category: 'Digestive Health',
    },
    {
        id: 5,
        name: 'Gyn-30',
        price: '59.99',
        smalldescription: 'Herbal Women’s Health',
        fullDescription: 'G Y N -30 Syrup: For gyneocological disorders in females Reduces pelvic congestion and uterine disorders The remarkable gynic formula with astringent, analgesic, anti-inflammatary and uterine sedative, effective on the endometrium and ovarian tissues. Very effective in menorrhagia and metrorrhagia, dysfunctional uterine bleeding and leucorrhoea. Regulates menstrual cycle. An excellent utero ovarian sedative and anodyne formulation. G Y N- 30 Capsules A gynic sedative in capsule form Natural, herbal formula, normalizes menstrual cycle and checks menorrhea. Enriched with proven natural herbs like ASHOKA, LODHRA and SATAVARI.',
        image: '../assets/images/gyn 30.png',
        rating: 4.7,
        reviews: 310,
        inStock: true,
        category: 'Women\'s Health',
    },

    {
        id: 6,
        name: 'RAPID UP',
        price: '59.99',
        smalldescription: 'Erectile Wellness Formula',
        fullDescription: 'Our NEWEST product RAPID UP is a unique combination for the treatment of erectile dysfunction and loss of libido. It reduces stress, depression and relaxes the mind for better performance.',
        image: '../assets/images/rapid up.png',
        rating: 4.7,
        reviews: 310,
        inStock: true,
        category: 'Men\'s Health',
    },

    {
        id: 7,
        name: 'FERTI FORTE CAPSULES',
        price: '59.99',
        smalldescription: 'Herbal Fertility Booster',
        fullDescription: 'A pioneer product for infertility in both males and females Combines all the time-tested and well-established herbal ingredients like Aswagandha, Atmgupta, Saphedhmisri, Anacylus, Saffron, Gomutrashilajit etc. Increases sperm count and motility in male, and corrects all menstrual and other problems in females Besides, Ferti-Forte improves body immunity and has high antioxident properties',
        image: '../assets/images/ferti forte capsules.png',
        rating: 4.7,
        reviews: 310,
        inStock: true,
        category: 'Wellness',
    },

    {
        id: 8,
        name: 'Sarmapain relief Balm',
        price: '59.99',
        smalldescription: 'All-Purpose Pain Balm',
        fullDescription: 'ur new product SARMA BALM is a unique balm for all pains',
        image: '../assets/images/sarma_balm.png',
        rating: 4.7,
        reviews: 310,
        inStock: true,
        category: 'Pain Relief',
    },

    {
        id: 9,
        name: 'NANNARI SYRUP',
        price: '59.99',
        smalldescription: 'Sugar-Free Herbal Syrup',
        fullDescription: 'NEW NANNARI Syrup (SUGAR FREE): (1,000 ml) Since huge number of people are diabetic now-a-days and for Those people who want to drink New Nannari without sugar, we have NEW NANARI (SUGAR FREE). Diabetic patients can safely, unhesitatingly take (taste) New Nannari and get the benefits of it. Sugar-free New Nannari is made of natural herbal ingredients (SWARASA) with canned sugar and tested, verified and documented on patients for better safety.',
        image: '../assets/images/nannari syrup.png',
        rating: 4.7,
        reviews: 310,
        inStock: true,
        category: 'Health Drinks',
    },

    {
        id: 10,
        name: 'NANNARI SHARABAT',
        price: '59.99',
        smalldescription: 'Herbal Summer Cooler',
        fullDescription: 'NEW NANNARI Syrup: (1,000 ml) South India’s No. 1 summer cool drink with excellent taste and flavour. Naturally derived, no artificial flavours added. Made from the roots of famous SUGANDHI PLANTS. The thick concentrate syrup contains the formula given by the ancient text books. New Nannari syrup keeps your body cool from over heat/summer heat instantly. Gives extra, instant energy, besides quenching the thirst. It replenishes the body imbalance of sodium/potassium salts thus protects you from dehydration. DATES SUGANDHI (SHARABAT): (1,000 ml) Made fortified with DATES for better cooling and energy gainer. Restores energy and immunity to body cells. A good laxative because of high dietery fibre. Protects colon.',
        image: '../assets/images/nannari sharabat.png',
        rating: 4.7,
        reviews: 310,
        inStock: true,
        category: 'Health Drinks',
    },

    {
        id: 11,
        name: 'RAGI MALT POWER',
        price: '59.99',
        smalldescription: 'Nutritious Raagi Malt',
        fullDescription: 'Sri Sai RAAGI MALT POWDER: (500 gms) Raagi is a well-known ancient cereal used as a whole food in old ages. This is used as a RAAGI JAWA (a semi solid state of Raagi by adding water to its quantity required and heat it for some time, take out and cool it and eat, if required add a little salt or sugar for taste. You can also add butter milk to enhance its taste). We prepare the Raagi Malt by thorough processing, sprouting for two days and roasted for safety and long shelf life. Only Raagi contains rich minerals, proteins and fibre. METIONINE – a protein is available only in Raagi and hence it is considered as the whole food. It improves metabolism, hydrolysis of fat is taken care. Hence raagi is very useful in controlling obesity.',
        image: '../assets/images/ragi malt power.png',
        rating: 4.7,
        reviews: 310,
        inStock: true,
        category: 'Health Foods',
    },

    {
        id: 12,
        name: 'HOHA_20',
        price: '59.99',
        smalldescription: 'Herbal Diabetes Control',
        fullDescription: 'Diabetics is a chronic metabolic disorder and damages every vital organ in the body slowly if it is not treated properly and on time. India has become a diabetic capital of the world. So it is the time to protect and prevent from spreading with a sure and definite drug to combat the problem. HOHA-20 contains mostly Tiktha pradhana dravyas (of bitter origin) Helps correct impairment of insulin secretion and activates BETA CELLS to various insulin secretogogues. Controls post-pradial hypoglycemia. Increases vasodailatory action to inflow in the pancreatic gland. Increases metabolic activity at tissue and cellular level. Can be safely taken along with other OHA DRUGS. Safely and gradually can reduce the dependence of OHA DRUGS. Protects from retinoneuropathy, kidney damage, weight loss and other metabolic debilitating conditions. The rational combination of age-old and time tested herbs.',
        image: '../assets/images/hoha_20.png',
        rating: 4.7,
        reviews: 310,
        inStock: true,
        category: 'Diabetes Care',
    },

    {
        id: 14,
        name: 'Mixed millet',
        price: '59.99',
        smalldescription: 'Multi-Grain Energy Mix',
        fullDescription: 'Our Mixed Millet Multi-Grain porridge is made from sprouted and roasted millets and is a whole mix for fitness and instant energy. It is 100% natural and contains more than 30 varieties of sprouts and cereals.',
        image: '../assets/images/mixed millet.png',
        rating: 4.7,
        reviews: 310,
        inStock: true,
        category: 'Health Foods',
    },
    
  {
    id: 15,
    name: 'Mixed Millet',
    price: '59.99',
    smalldescription: 'Multi-Grain Energy Mix',
    fullDescription: 'Our Mixed Millet Multi-Grain porridge is made from sprouted and roasted millets and is a whole mix for fitness and instant energy. It is 100% natural and contains more than 30 varieties of sprouts and cereals.',
    image: '../assets/images/mixed millet.png',
    rating: 4.7,
    reviews: 310,
    inStock: true,
    category: 'Health Foods',
  },
  {
    id: 16,
    name: 'Organic Quinoa',
    price: '12.50',
    smalldescription: 'High Protein Superfood',
    fullDescription: 'Premium white organic quinoa. A complete protein source packed with essential amino acids and fiber. Perfect for salads and bowls.',
    image: '../assets/images/organic quinoa.png',
    rating: 4.8,
    reviews: 150,
    inStock: true,
    category: 'Health Foods',
  },
  {
    id: 17,
    name: 'Chia Seeds',
    price: '8.99',
    smalldescription: 'Omega-3 Rich Seeds',
    fullDescription: 'Raw, organic chia seeds. Excellent source of Omega-3 fatty acids, fiber, and antioxidants. Great for smoothies and puddings.',
    image: '../assets/images/chia seeds.png',
    rating: 4.5,
    reviews: 220,
    inStock: true,
    category: 'Health Foods',
  },
  {
    id: 18,
    name: 'Almond Butter',
    price: '15.99',
    smalldescription: 'Creamy & Unsweetened',
    fullDescription: 'Made from 100% roasted almonds with no added sugar or preservatives. A healthy alternative to peanut butter.',
    image: '../assets/images/almond butter.png',
    rating: 4.9,
    reviews: 85,
    inStock: false,
    category: 'Health Foods',
  },
  {
    id: 19,
    name: 'Green Tea Box',
    price: '6.49',
    smalldescription: 'Detox & Refresh',
    fullDescription: 'Premium hand-picked green tea leaves. Rich in antioxidants to boost metabolism and improve brain function.',
    image: '../assets/images/green tea.png',
    rating: 4.6,
    reviews: 410,
    inStock: true,
    category: 'Health Foods',
  },
  {
    id: 20,
    name: 'Protein Granola',
    price: '9.99',
    smalldescription: 'Crunchy Breakfast Mix',
    fullDescription: 'Oats, honey, and nuts baked to perfection. Enriched with whey protein for a post-workout recovery meal.',
    image: '../assets/images/protein granola.png',
    rating: 4.7,
    reviews: 120,
    inStock: true,
    category: 'Health Foods',
  },
  {
    id: 21,
    name: 'Manuka Honey',
    price: '35.00',
    smalldescription: 'Raw New Zealand Honey',
    fullDescription: 'Certified UMF 10+ Manuka Honey. Known for its potent antibacterial properties and immune system support.',
    image: '../assets/images/manuka honey.png',
    rating: 4.9,
    reviews: 600,
    inStock: true,
    category: 'Health Foods',
  },
  {
    id: 22,
    name: 'Dried Cranberries',
    price: '7.50',
    smalldescription: 'Tart & Sweet Snack',
    fullDescription: 'Whole dried cranberries sweetened with apple juice. A perfect topping for oatmeal or a standalone healthy snack.',
    image: '../assets/images/dried cranberries.png',
    rating: 4.4,
    reviews: 95,
    inStock: true,
    category: 'Health Foods',
  },
  {
    id: 23,
    name: 'Flaxseed Powder',
    price: '5.99',
    smalldescription: 'Ground Super Seeds',
    fullDescription: 'Cold-milled flaxseed powder to preserve nutrients. High in fiber and lignans for heart health.',
    image: '../assets/images/flaxseed powder.png',
    rating: 4.3,
    reviews: 70,
    inStock: true,
    category: 'Health Foods',
  },
  {
    id: 24,
    name: 'Coconut Oil',
    price: '11.25',
    smalldescription: 'Cold Pressed Virgin Oil',
    fullDescription: 'Extra virgin coconut oil suitable for cooking, baking, and skin care. 100% organic and unrefined.',
    image: '../assets/images/coconut oil.png',
    rating: 4.8,
    reviews: 330,
    inStock: true,
    category: 'Health Foods',
  },

  // --- Category: Electronics ---
  {
    id: 25,
    name: 'Wireless Earbuds',
    price: '49.99',
    smalldescription: 'Deep Bass & Noise Cancelling',
    fullDescription: 'True wireless earbuds with active noise cancellation, 24-hour battery life, and water resistance.',
    image: '../assets/images/wireless earbuds.png',
    rating: 4.5,
    reviews: 1200,
    inStock: true,
    category: 'Electronics',
  },
  {
    id: 26,
    name: 'Smart Watch Gen 5',
    price: '199.00',
    smalldescription: 'Fitness Tracker & GPS',
    fullDescription: 'Advanced health monitoring, heart rate tracking, sleep analysis, and built-in GPS for runners.',
    image: '../assets/images/smart watch.png',
    rating: 4.6,
    reviews: 850,
    inStock: true,
    category: 'Electronics',
  },
  {
    id: 27,
    name: 'Bluetooth Speaker',
    price: '39.50',
    smalldescription: 'Portable 360 Sound',
    fullDescription: 'Compact waterproof speaker with booming bass and 12 hours of playtime. Perfect for outdoor parties.',
    image: '../assets/images/bluetooth speaker.png',
    rating: 4.4,
    reviews: 500,
    inStock: true,
    category: 'Electronics',
  },
  {
    id: 28,
    name: '4K Action Camera',
    price: '129.99',
    smalldescription: 'Waterproof Sports Cam',
    fullDescription: 'Capture your adventures in stunning 4K resolution. Includes waterproof casing and mounting kit.',
    image: '../assets/images/action camera.png',
    rating: 4.3,
    reviews: 210,
    inStock: false,
    category: 'Electronics',
  },
  {
    id: 29,
    name: 'Gaming Mouse',
    price: '29.99',
    smalldescription: 'RGB & Programmable Buttons',
    fullDescription: 'Ergonomic gaming mouse with adjustable DPI sensor and customizable RGB lighting effects.',
    image: '../assets/images/gaming mouse.png',
    rating: 4.7,
    reviews: 900,
    inStock: true,
    category: 'Electronics',
  },
  {
    id: 30,
    name: 'Mechanical Keyboard',
    price: '89.99',
    smalldescription: 'Tactile Blue Switches',
    fullDescription: 'Full-sized mechanical keyboard with tactile feedback, anti-ghosting keys, and durable aluminum frame.',
    image: '../assets/images/mechanical keyboard.png',
    rating: 4.8,
    reviews: 450,
    inStock: true,
    category: 'Electronics',
  },
  {
    id: 31,
    name: 'USB-C Hub',
    price: '24.99',
    smalldescription: '7-in-1 Adapter',
    fullDescription: 'Expand your laptop connectivity with HDMI, USB 3.0, SD card reader, and PD charging port.',
    image: '../assets/images/usbc hub.png',
    rating: 4.5,
    reviews: 320,
    inStock: true,
    category: 'Electronics',
  },
  {
    id: 32,
    name: 'Power Bank 20000mAh',
    price: '35.00',
    smalldescription: 'Fast Charging Portable Battery',
    fullDescription: 'High capacity power bank capable of charging smartphones multiple times. Supports Quick Charge 3.0.',
    image: '../assets/images/power bank.png',
    rating: 4.6,
    reviews: 780,
    inStock: true,
    category: 'Electronics',
  },
  {
    id: 33,
    name: 'Noise Cancelling Headphones',
    price: '249.99',
    smalldescription: 'Over-Ear Premium Audio',
    fullDescription: 'Industry-leading noise cancellation technology with plush ear cushions for long listening sessions.',
    image: '../assets/images/headphones.png',
    rating: 4.9,
    reviews: 1500,
    inStock: true,
    category: 'Electronics',
  },
  {
    id: 34,
    name: 'Drone Mini',
    price: '299.00',
    smalldescription: 'HD Camera Quadcopter',
    fullDescription: 'Lightweight drone with HD camera, stable hovering, and easy-to-use flight controls for beginners.',
    image: '../assets/images/drone mini.png',
    rating: 4.4,
    reviews: 130,
    inStock: true,
    category: 'Electronics',
  },

  // --- Category: Fashion ---
  {
    id: 35,
    name: 'Classic White Tee',
    price: '19.99',
    smalldescription: '100% Cotton Crew Neck',
    fullDescription: 'Essential white t-shirt made from premium organic cotton. Breathable fabric and relaxed fit.',
    image: '../assets/images/white tee.png',
    rating: 4.5,
    reviews: 2000,
    inStock: true,
    category: 'Fashion',
  },
  {
    id: 36,
    name: 'Denim Jacket',
    price: '65.00',
    smalldescription: 'Vintage Wash Style',
    fullDescription: 'Timeless denim jacket with a vintage wash finish. Features button-flap chest pockets and side pockets.',
    image: '../assets/images/denim jacket.png',
    rating: 4.7,
    reviews: 450,
    inStock: true,
    category: 'Fashion',
  },
  {
    id: 37,
    name: 'Running Sneakers',
    price: '89.50',
    smalldescription: 'Lightweight & Cushioned',
    fullDescription: 'Performance running shoes designed for comfort and speed. Breathable mesh upper and shock-absorbing sole.',
    image: '../assets/images/running sneakers.png',
    rating: 4.6,
    reviews: 600,
    inStock: true,
    category: 'Fashion',
  },
  {
    id: 38,
    name: 'Leather Wallet',
    price: '34.99',
    smalldescription: 'Genuine Leather Bifold',
    fullDescription: 'Handcrafted genuine leather wallet with RFID blocking technology. Slim profile with multiple card slots.',
    image: '../assets/images/leather wallet.png',
    rating: 4.8,
    reviews: 310,
    inStock: true,
    category: 'Fashion',
  },
  {
    id: 39,
    name: 'Aviator Sunglasses',
    price: '25.00',
    smalldescription: 'UV400 Protection',
    fullDescription: 'Classic aviator style sunglasses with polarized lenses to reduce glare and protect your eyes.',
    image: '../assets/images/aviator sunglasses.png',
    rating: 4.4,
    reviews: 180,
    inStock: true,
    category: 'Fashion',
  },
  {
    id: 40,
    name: 'Floral Summer Dress',
    price: '45.00',
    smalldescription: 'Light & Breezy',
    fullDescription: 'Beautiful floral print dress perfect for summer outings. Made from soft rayon fabric.',
    image: '../assets/images/floral dress.png',
    rating: 4.5,
    reviews: 220,
    inStock: true,
    category: 'Fashion',
  },
  {
    id: 41,
    name: 'Canvas Backpack',
    price: '49.99',
    smalldescription: 'Laptop Compartment Bag',
    fullDescription: 'Durable canvas backpack with a padded laptop sleeve and multiple pockets for organization.',
    image: '../assets/images/canvas backpack.png',
    rating: 4.6,
    reviews: 550,
    inStock: true,
    category: 'Fashion',
  },
  {
    id: 42,
    name: 'Chino Pants',
    price: '39.99',
    smalldescription: 'Slim Fit Stretch',
    fullDescription: 'Versatile chino pants that work for casual or semi-formal looks. Stretch fabric ensures all-day comfort.',
    image: '../assets/images/chino pants.png',
    rating: 4.3,
    reviews: 300,
    inStock: true,
    category: 'Fashion',
  },
  {
    id: 43,
    name: 'Wool Beanie',
    price: '15.00',
    smalldescription: 'Winter Warmth',
    fullDescription: 'Cozy knitted beanie made from a wool blend. One size fits all, available in multiple colors.',
    image: '../assets/images/wool beanie.png',
    rating: 4.7,
    reviews: 150,
    inStock: true,
    category: 'Fashion',
  },
  {
    id: 44,
    name: 'Leather Belt',
    price: '22.50',
    smalldescription: 'Classic Buckle',
    fullDescription: 'Full-grain leather belt with a durable metal buckle. A staple accessory for any wardrobe.',
    image: '../assets/images/leather belt.png',
    rating: 4.5,
    reviews: 210,
    inStock: true,
    category: 'Fashion',
  },

  // --- Category: Home & Kitchen ---
  {
    id: 45,
    name: 'Ceramic Non-Stick Pan',
    price: '35.00',
    smalldescription: 'Toxin-Free Cookware',
    fullDescription: 'Eco-friendly ceramic coating that is free from PTFE and PFOA. Even heat distribution for perfect cooking.',
    image: '../assets/images/ceramic pan.png',
    rating: 4.6,
    reviews: 340,
    inStock: true,
    category: 'Home & Kitchen',
  },
  {
    id: 46,
    name: 'Coffee Maker',
    price: '79.99',
    smalldescription: 'Programmable Drip Brewer',
    fullDescription: '12-cup coffee maker with programmable timer and auto-shutoff feature. Brew strength control included.',
    image: '../assets/images/coffee maker.png',
    rating: 4.5,
    reviews: 890,
    inStock: true,
    category: 'Home & Kitchen',
  },
  {
    id: 47,
    name: 'Memory Foam Pillow',
    price: '29.99',
    smalldescription: 'Orthopedic Neck Support',
    fullDescription: 'Contoured memory foam pillow designed to support the neck and spine during sleep. Breathable cover.',
    image: '../assets/images/memory pillow.png',
    rating: 4.4,
    reviews: 600,
    inStock: true,
    category: 'Home & Kitchen',
  },
  {
    id: 48,
    name: 'Air Fryer',
    price: '89.00',
    smalldescription: 'Oil-Free Frying',
    fullDescription: 'Cook healthy meals with up to 85% less fat. Digital touchscreen with 8 preset cooking modes.',
    image: '../assets/images/air fryer.png',
    rating: 4.8,
    reviews: 1100,
    inStock: true,
    category: 'Home & Kitchen',
  },
  {
    id: 49,
    name: 'Bamboo Cutting Board',
    price: '18.50',
    smalldescription: 'Organic Wood Chopping Board',
    fullDescription: 'Heavy-duty bamboo board that is gentle on knives and naturally antibacterial. Easy to clean.',
    image: '../assets/images/cutting board.png',
    rating: 4.7,
    reviews: 230,
    inStock: true,
    category: 'Home & Kitchen',
  },
  {
    id: 50,
    name: 'Stainless Steel Water Bottle',
    price: '14.99',
    smalldescription: 'Vacuum Insulated Flask',
    fullDescription: 'Keeps drinks cold for 24 hours or hot for 12 hours. Leak-proof cap and durable construction.',
    image: '../assets/images/water bottle.png',
    rating: 4.8,
    reviews: 500,
    inStock: true,
    category: 'Home & Kitchen',
  },
  {
    id: 51,
    name: 'LED Desk Lamp',
    price: '25.00',
    smalldescription: 'Dimmable Eye-Care Light',
    fullDescription: 'Adjustable gooseneck lamp with touch control brightness. Flicker-free light to reduce eye strain.',
    image: '../assets/images/desk lamp.png',
    rating: 4.5,
    reviews: 310,
    inStock: true,
    category: 'Home & Kitchen',
  },
  {
    id: 52,
    name: 'Bath Towel Set',
    price: '39.99',
    smalldescription: '100% Cotton Plush',
    fullDescription: 'Set of 4 luxury bath towels. Highly absorbent and soft against the skin. Fade-resistant colors.',
    image: '../assets/images/towel set.png',
    rating: 4.3,
    reviews: 180,
    inStock: true,
    category: 'Home & Kitchen',
  },
  {
    id: 53,
    name: 'Kitchen Knife Set',
    price: '55.00',
    smalldescription: '5-Piece Chef Set',
    fullDescription: 'High-carbon stainless steel blades with ergonomic handles. Includes chef knife, paring knife, and utility knife.',
    image: '../assets/images/knife set.png',
    rating: 4.6,
    reviews: 400,
    inStock: false,
    category: 'Home & Kitchen',
  },
  {
    id: 54,
    name: 'Succulent Plant Pot',
    price: '12.99',
    smalldescription: 'Decorative Ceramic Pot',
    fullDescription: 'Minimalist white ceramic pot with bamboo tray. Perfect for small succulents and indoor plants.',
    image: '../assets/images/plant pot.png',
    rating: 4.9,
    reviews: 150,
    inStock: true,
    category: 'Home & Kitchen',
  },

  // --- Category: Beauty ---
  {
    id: 55,
    name: 'Vitamin C Serum',
    price: '22.00',
    smalldescription: 'Brightening & Anti-Aging',
    fullDescription: 'Concentrated serum to reduce dark spots and boost collagen. Leaves skin glowing and radiant.',
    image: '../assets/images/vitamin serum.png',
    rating: 4.7,
    reviews: 900,
    inStock: true,
    category: 'Beauty',
  },
  {
    id: 56,
    name: 'Hydrating Moisturizer',
    price: '18.50',
    smalldescription: 'Daily Face Cream',
    fullDescription: 'Lightweight, oil-free moisturizer enriched with Hyaluronic Acid for 24-hour hydration.',
    image: '../assets/images/moisturizer.png',
    rating: 4.6,
    reviews: 650,
    inStock: true,
    category: 'Beauty',
  },
  {
    id: 57,
    name: 'Matte Lipstick',
    price: '14.00',
    smalldescription: 'Long-Lasting Color',
    fullDescription: 'Velvety matte finish that stays on all day without drying lips. Available in deep red and nude shades.',
    image: '../assets/images/matte lipstick.png',
    rating: 4.5,
    reviews: 300,
    inStock: true,
    category: 'Beauty',
  },
  {
    id: 58,
    name: 'Charcoal Face Mask',
    price: '10.99',
    smalldescription: 'Deep Cleansing Clay',
    fullDescription: 'Activated charcoal mask that draws out impurities and unclogs pores. Great for oily skin.',
    image: '../assets/images/face mask.png',
    rating: 4.4,
    reviews: 220,
    inStock: true,
    category: 'Beauty',
  },
  {
    id: 59,
    name: 'Argan Hair Oil',
    price: '16.99',
    smalldescription: 'Frizz Control Treatment',
    fullDescription: 'Pure Moroccan Argan oil to repair split ends and add shine to dull hair. Non-greasy formula.',
    image: '../assets/images/argan oil.png',
    rating: 4.8,
    reviews: 410,
    inStock: true,
    category: 'Beauty',
  },
  {
    id: 60,
    name: 'Sunscreen SPF 50',
    price: '19.50',
    smalldescription: 'Broad Spectrum Protection',
    fullDescription:'Water-resistant sunscreen lotion that protects against UVA and UVB rays. No white cast.',
    image: '../assets/images/sunscreen.png',
    rating: 4.7,
    reviews: 500,
    inStock: true,
    category: 'Beauty',
  },
  {
    id: 61,
    name: 'Exfoliating Body Scrub',
    price: '13.50',
    smalldescription: 'Coffee & Coconut',
    fullDescription: 'Natural coffee grounds scrub to remove dead skin cells and improve circulation. Smells divine.',
    image: '../assets/images/body scrub.png',
    rating: 4.6,
    reviews: 280,
    inStock: true,
    category: 'Beauty',
  },
  {
    id: 62,
    name: 'Facial Cleanser',
    price: '11.00',
    smalldescription: 'Gentle Foaming Wash',
    fullDescription: 'Daily face wash that removes makeup and dirt without stripping natural oils. Suitable for sensitive skin.',
    image: '../assets/images/cleanser.png',
    rating: 4.5,
    reviews: 350,
    inStock: true,
    category: 'Beauty',
  },
  {
    id: 63,
    name: 'Eau De Parfum',
    price: '55.00',
    smalldescription: 'Floral & Woody Scent',
    fullDescription: 'A long-lasting fragrance with notes of jasmine, rose, and sandalwood. Elegant glass bottle.',
    image: '../assets/images/perfume.png',
    rating: 4.8,
    reviews: 120,
    inStock: true,
    category: 'Beauty',
  },
  {
    id: 64,
    name: 'Lavender Essential Oil',
    price: '9.99',
    smalldescription: 'Relaxation & Sleep',
    fullDescription: '100% pure therapeutic grade essential oil. Perfect for diffusers to create a calming atmosphere.',
    image: '../assets/images/lavender oil.png',
    rating: 4.9,
    reviews: 400,
    inStock: true,
    category: 'Beauty',
  }
];